import React from 'react';

import {
	TEXT_COLOR_HIGHLIGHT_GROUP,
	TEXT_SECTION,
	TEXT_SECTION_PRIMARY_TOOLBAR,
	TEXT_SECTION_PRIMARY_TOOLBAR_RANK,
	TEXT_SECTION_RANK,
} from '@atlaskit/editor-common/toolbar';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { ToolbarButtonGroup } from '@atlaskit/editor-toolbar';
import type { RegisterComponent, ToolbarComponentTypes } from '@atlaskit/editor-toolbar-model';

import type { CompanyHubTextColorPlugin } from '../companyHubTextColorPluginType';

import { CompanyHubTextColorButton } from './toolbar-components/CompanyHubTextColorButton';

export const getToolbarComponents = (
	api: ExtractInjectionAPI<CompanyHubTextColorPlugin> | undefined,
): RegisterComponent[] => {
	return [
		{
			...TEXT_COLOR_HIGHLIGHT_GROUP,
			parents: [
				{
					...TEXT_SECTION,
					rank: TEXT_SECTION_RANK[TEXT_COLOR_HIGHLIGHT_GROUP.key],
				},
				{
					type: TEXT_SECTION_PRIMARY_TOOLBAR.type,
					key: TEXT_SECTION_PRIMARY_TOOLBAR.key,
					rank: TEXT_SECTION_PRIMARY_TOOLBAR_RANK[TEXT_COLOR_HIGHLIGHT_GROUP.key],
				},
			],
			component: ({ children }: { children: React.ReactNode }) => (
				<ToolbarButtonGroup>{children}</ToolbarButtonGroup>
			),
		},
		{
			type: 'button',
			key: 'company-hub-text-color-button-inline-toolbar',
			parents: [
				{
					...TEXT_COLOR_HIGHLIGHT_GROUP,
					rank: 100,
				},
			],
			component: ({ parents }: { parents: ToolbarComponentTypes }) => (
				<CompanyHubTextColorButton api={api} parents={parents} />
			),
		},
	];
};
